import './Logo.scss';

export const Logo = ({ variant = 'default' }) => {
    return (
        <a href='/' className={`logo-container logo--${variant}`}>
            <div className="logo-brand">
                <span className="text-alpa">Alpa</span>
                <span className="text-kit">Kit</span>
            </div>
            <div className="logo-sub">cleaning</div>
        </a>
    );
};